import { render, staticRenderFns } from "./FileManagerTableItemFolder.vue?vue&type=template&id=47d48798&scoped=true&"
import script from "./FileManagerTableItemFolder.vue?vue&type=script&lang=ts&"
export * from "./FileManagerTableItemFolder.vue?vue&type=script&lang=ts&"
import style0 from "./FileManagerTableItemFolder.vue?vue&type=style&index=0&id=47d48798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d48798",
  null
  
)

export default component.exports